/**
 * Dev bypass token storage — browser target: localStorage, so the token
 * survives reloads and Playwright storage states can carry it
 * (`e2e/web/utils/auth.ts`). No key material and no signing code lives here.
 */

import { DEV_AUTH_TOKEN_KEY } from '../config';
import type { DevTokenStore } from '../core/devAuth';

/** Same-tab notification channel; the `storage` event only fires cross-tab. */
const DEV_AUTH_CHANGED_EVENT = 'dev-auth-token-changed';

export const localStorageDevTokenStore: DevTokenStore = {
  get: () => localStorage.getItem(DEV_AUTH_TOKEN_KEY),
  set: (token) => {
    localStorage.setItem(DEV_AUTH_TOKEN_KEY, token);
    window.dispatchEvent(new Event(DEV_AUTH_CHANGED_EVENT));
  },
  clear: () => {
    localStorage.removeItem(DEV_AUTH_TOKEN_KEY);
    window.dispatchEvent(new Event(DEV_AUTH_CHANGED_EVENT));
  },
  // Same tab and cross-tab.
  subscribe: (callback) => {
    window.addEventListener(DEV_AUTH_CHANGED_EVENT, callback);
    window.addEventListener('storage', callback);
    return () => {
      window.removeEventListener(DEV_AUTH_CHANGED_EVENT, callback);
      window.removeEventListener('storage', callback);
    };
  },
};
